document.addEventListener('DOMContentLoaded', () => {
  const btnSizeOpen = document.querySelector('[data-open-size-guide]');
  const sizeGuideWrapper = document.querySelector('[data-size-guide]');
  const btnSizeGuideClose = document.querySelector('[data-size-guide-close]');

  if (btnSizeOpen && sizeGuideWrapper) {
    btnSizeOpen.addEventListener('click', (e) => {
      e.preventDefault();
      sizeGuideWrapper.classList.add('is-open');
    });
  }

  if (btnSizeGuideClose && sizeGuideWrapper) {
    btnSizeGuideClose.addEventListener('click', (e) => {
      e.preventDefault();
      sizeGuideWrapper.classList.remove('is-open');
    });
  }
});
